import {
	Component,
	EventEmitter,
	Input,
	OnDestroy,
	OnInit,
	Output,
	Signal,
	ViewEncapsulation,
	signal,
} from '@angular/core';
import { FormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { NgSelectComponent } from '@ng-select/ng-select';
import { LANGUAGES } from 'app/config/language.constants';
import { Language } from 'app/shared/models/models.model';
import { Subject } from 'rxjs';

interface Scope {
	data: any;
	loading: Signal<boolean>;
	userCanEdit: boolean;
	userCanNew: boolean;
}

@Component({
	selector: 'ms-select-language',
	templateUrl: './ms-select-language.component.html',
	styleUrls: ['./ms-select-language.component.scss'],
	encapsulation: ViewEncapsulation.None,
	standalone: false,
})
export class MsSelectLanguageComponent implements OnInit, OnDestroy {
	@Input() formGroup: FormGroup;
	@Input() title: string;
	@Input() key: string;
	@Output() change = new EventEmitter();

	languages = LANGUAGES;

	public scope: Scope = {
		data: signal<Language[]>([]),
		loading: signal(false),
		userCanEdit: false,
		userCanNew: false,
	};
	private _unsubscribeAll: Subject<any> = new Subject<any>();

	/**
	 * Constructor
	 */
	constructor(private _formBuilder: UntypedFormBuilder) {
		this.scope.loading = signal(false);
		if (!this.formGroup) {
			this.formGroup = this._formBuilder.group({
				name: [null, [Validators.required]],
			});
		}
	}

	// -----------------------------------------------------------------------------------------------------
	// @ Lifecycle hooks
	// -----------------------------------------------------------------------------------------------------

	/**
	 * On init
	 */
	ngOnInit(): void {
		this._setValue();
		this._findAll();
	}

	/**
	 * On destroy
	 */
	ngOnDestroy(): void {
		// Unsubscribe from all subscriptions
		this._unsubscribeAll.next(null);
		this._unsubscribeAll.complete();
	}

	// -----------------------------------------------------------------------------------------------------
	// @ Public methods
	// -----------------------------------------------------------------------------------------------------

	compareFn(a, b): boolean {
		return a.id === b.id;
	}

	createNew(select: NgSelectComponent) {
		select.close();
	}

	edit($event, data, select: NgSelectComponent) {
		select.close();
	}

	valueChangeHandle(val) {
		let _value = undefined;
		if (val !== undefined && val !== null) {
			_value = val;
			this.formGroup.get(this.key).setValue(_value);
		}
		this.change.emit(_value);
	}

	// -----------------------------------------------------------------------------------------------------
	// @ Private methods
	// -----------------------------------------------------------------------------------------------------
	private _setValue() {
		let _value = this.formGroup.get(this.key).value;
		if (_value !== '' && _value !== null && _value !== undefined) {
			this.formGroup.get(this.key).setValue({ id: _value, name: _value });
		}
	}

	private _setSelectedFirstOfEmpty() {
		const _value = this.formGroup.get(this.key).value;
		if (_value === '' || _value === null || _value === undefined) {
			const _data = this.scope.data;
			if (_data.length > 0) {
				const _value = _data[0];
				this.formGroup.get(this.key).setValue(_value);
				this.valueChangeHandle(_value);
			}
		}
	}

	private async _findAll() {
		this.scope.loading = signal(true);
		this.scope.data = [];
		await this.languages.forEach((item) => {
			const _value = { id: item, name: item };
			this.scope.data.push(_value);
		});
		this._setSelectedFirstOfEmpty();
		this.scope.loading = signal(false);
	}
}
